import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';

class PayoutApiClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/payout');
  }
}

export default PayoutApiClient;
